// extracted by mini-css-extract-plugin
export default {"priceContainer":"dna-z","discountedPrice":"ena-z","originalPrice":"fna-z","productPrice":"gna-z"};